import {useEffect, useRef} from "react";

import {useSwipe} from "@pg-mono/hooks";
import {throttle} from "@pg-mono/nodash";

interface IProps {
    onPrevReel: () => void;
    onNextReel: () => void;
    disableNavigation?: boolean;
}

const MIN_SWIPE_DELTA = 70;

export const useReelsNavigation = (props: IProps) => {
    const scrollableWrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.disableNavigation) {
            return;
        }
        const onKeyPress = throttle((event: KeyboardEvent) => {
            switch (event.key) {
                case "ArrowUp":
                    props.onPrevReel();
                    break;
                case "ArrowDown":
                    props.onNextReel();
                    break;
                default:
                    return;
            }
        }, 1000);

        window.addEventListener("keydown", onKeyPress);

        return () => {
            window.removeEventListener("keydown", onKeyPress);
        };
    }, [props.disableNavigation]);

    useEffect(() => {
        if (!scrollableWrapperRef.current || props.disableNavigation) {
            return;
        }

        const onReelChange = throttle((deltaY: number) => {
            if (deltaY > 0) {
                props.onNextReel();
            } else {
                props.onPrevReel();
            }
        }, 1000);

        const onWheel = (event: WheelEvent) => {
            event.preventDefault();
            event.stopPropagation();
            onReelChange(event.deltaY);
        };

        scrollableWrapperRef.current.addEventListener("wheel", onWheel);

        return () => {
            scrollableWrapperRef.current?.removeEventListener("wheel", onWheel);
        };
    }, [scrollableWrapperRef.current, props.disableNavigation]);

    useSwipe({
        element: scrollableWrapperRef.current,
        disable: props.disableNavigation,
        disableTouchScroll: true,
        onSwipeUp: ({delta}) => {
            if (delta > MIN_SWIPE_DELTA) {
                props.onNextReel();
            }
        },
        onSwipeDown: ({delta}) => {
            if (delta > MIN_SWIPE_DELTA) {
                props.onPrevReel();
            }
        }
    });

    return {
        scrollableWrapperRef
    };
};
import {useEffect, useRef} from "react";

import {useSwipe} from "@pg-mono/hooks";
import {throttle} from "@pg-mono/nodash";

interface IProps {
    onPrevReel: () => void;
    onNextReel: () => void;
    disableNavigation?: boolean;
}

const MIN_SWIPE_DELTA = 70;

export const useReelsNavigation = (props: IProps) => {
    const scrollableWrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.disableNavigation) {
            return;
        }
        const onKeyPress = throttle((event: KeyboardEvent) => {
            switch (event.key) {
                case "ArrowUp":
                    props.onPrevReel();
                    break;
                case "ArrowDown":
                    props.onNextReel();
                    break;
                default:
                    return;
            }
        }, 1000);

        window.addEventListener("keydown", onKeyPress);

        return () => {
            window.removeEventListener("keydown", onKeyPress);
        };
    }, [props.disableNavigation]);

    useEffect(() => {
        if (!scrollableWrapperRef.current || props.disableNavigation) {
            return;
        }

        const onReelChange = throttle((deltaY: number) => {
            if (deltaY > 0) {
                props.onNextReel();
            } else {
                props.onPrevReel();
            }
        }, 1000);

        const onWheel = (event: WheelEvent) => {
            event.preventDefault();
            event.stopPropagation();
            onReelChange(event.deltaY);
        };

        scrollableWrapperRef.current.addEventListener("wheel", onWheel);

        return () => {
            scrollableWrapperRef.current?.removeEventListener("wheel", onWheel);
        };
    }, [scrollableWrapperRef.current, props.disableNavigation]);

    useSwipe({
        element: scrollableWrapperRef.current,
        disable: props.disableNavigation,
        disableTouchScroll: true,
        onSwipeUp: ({delta}) => {
            if (delta > MIN_SWIPE_DELTA) {
                props.onNextReel();
            }
        },
        onSwipeDown: ({delta}) => {
            if (delta > MIN_SWIPE_DELTA) {
                props.onPrevReel();
            }
        }
    });

    return {
        scrollableWrapperRef
    };
};
